import React from 'react';
import { Link } from 'react-router-dom';
import { Popover, Button, Icon, Tree, Tooltip } from 'antd';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import loadFinished from 'assets/images/icon-load-finish.png';
import editIcon from 'assets/images/icon-edit.png';
import { getStore } from 'utils/localStorage';
import Enums from 'utils/EnumsManager';
import styles from './index.less';

const { LocalStorageKeys } = Enums;
const { User } = LocalStorageKeys;

const cx = classNames.bind(styles);
const { TreeNode, DirectoryTree } = Tree;
const defaultProps = {
  reportOptions: [],
};
const propTypes = {
  rightSideData: PropTypes.object.isRequired,
  reportOptions: PropTypes.array,
  activeDashboard: PropTypes.string.isRequired,
  setActiveDashboard: PropTypes.func.isRequired,
  fetchDashboardReportData: PropTypes.func.isRequired,
  refreshReport: PropTypes.func.isRequired,
};
class PanelAction extends React.Component {
  state = {
    visible: false,
  };
  handleUpdate = () => {
    const { activeDashboard, refreshReport } = this.props;
    refreshReport(activeDashboard);
  };
  // selectKeys is an Array, if the option is single choice, then the length of Array is always be 1
  handleSelection = (selectKeys) => {
    const { setActiveDashboard, fetchDashboardReportData, activeDashboard } =
      this.props;
    if (!_.isEmpty(selectKeys) && selectKeys[0] !== activeDashboard) {
      setActiveDashboard(selectKeys[0]);
      fetchDashboardReportData(selectKeys[0]);
      this.setState({ visible: false });
    }
  };
  handleVisibleChange = (visible) => {
    this.setState({ visible });
  };
  renderTreeNodes = (reportOptions) => {
    if (_.isArray(reportOptions) && !_.isEmpty(reportOptions)) {
      return reportOptions.map((value) => {
        if (_.isArray(value.slots)) {
          return (
            <TreeNode title={value.name} key={value.id} selectable={false}>
              {this.renderTreeNodes(value.slots)}
            </TreeNode>
          );
        }
        return (
          <TreeNode
            isLeaf
            title={value.name}
            key={value.id}
            icon={
              value.updated ? (
                <img
                  src={loadFinished}
                  alt=""
                  className={cx('tree-node-img')}
                />
              ) : (
                <Icon />
              )
            }
          />
        );
      });
    }
    return [];
  };
  render() {
    const { rightSideData, reportOptions, activeDashboard } = this.props;
    const userInfo = JSON.parse(getStore(User));
    const userId = userInfo.id;

    const content = (
      <DirectoryTree
        showIcon
        className="dashboard-action-tree"
        selectedKeys={[activeDashboard]}
        defaultExpandedKeys={[activeDashboard]}
        onSelect={(selectKeys) => this.handleSelection(selectKeys)}
      >
        {this.renderTreeNodes(reportOptions)}
      </DirectoryTree>
    );

    const isRefreshButtonDisable =
    rightSideData.is_refreshing
    || _.isEmpty(activeDashboard)
    || (rightSideData.dashboard_slots && rightSideData.dashboard_slots.length === 0);

    return (
      <div>
        {rightSideData &&
          rightSideData.dashboard_folder &&
          rightSideData.dashboard_folder.belonged_user_id === userId && (
            <Link to={`/dashboards/${activeDashboard}/settings`}>
              <Button ghost className={cx('dashboard-report-edit')}>
                <img src={editIcon} alt="" className={cx('edit-icon')} />
                <FormattedMessage
                  id="page.dashboard.edit"
                  defaultMessage="Edit"
                />
              </Button>
            </Link>
          )}
        <Popover
          placement="bottom"
          content={content}
          trigger="click"
          visible={this.state.visible}
          onVisibleChange={this.handleVisibleChange}
        >
          <Button className={`btn-ellipse ml-sm panelBtn ${cx('text-btn')}`}>
            <FormattedMessage
              id="page.dashboard.changeDashboard"
              defaultMessage="Change Dashboard"
            />
            <Icon
              type="down"
              className={cx('down-icon')}
              style={{ float: 'right' }}
            />
          </Button>
        </Popover>
        {isRefreshButtonDisable ? (
          <Button
            className={`btn-ellipse ml-sm panelBtn ${cx('text-btn')}`}
            disabled
          >
            <Icon
              type="sync"
              className={cx('text-btn-sync')}
              spin={rightSideData.is_refreshing}
            />
            <FormattedMessage
              id={
                rightSideData.is_refreshing ?
                'page.dashboard.updating' : 'page.dashboard.updated'
              }
              defaultMessage="Updating"
            />
          </Button>
          ) : (
            <Tooltip
              title={<FormattedMessage id="page.dashboard.updateAllReports" />}
            >
              <Button
                className={`btn-ellipse ml-sm panelBtn ${cx('text-btn')}`}
                onClick={this.handleUpdate}
              >
                <Icon
                  type="sync"
                  className={cx('text-btn-sync')}
                />
                <FormattedMessage
                  id="page.dashboard.updated"
                  defaultMessage="Updated"
                />
              </Button>
            </Tooltip>
          )}
      </div>
    );
  }
}
PanelAction.defaultProps = defaultProps;
PanelAction.propTypes = propTypes;
export default PanelAction;



// WEBPACK FOOTER //
// ./src/views/Dashboard/components/rightSection/panelAction.jsx